export default "__VITE_ASSET__Be6fbVJJ__"